<template>
    <DashboardContainer>
        <Dealers></Dealers>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../../containers/DashboardContainer'
import Dealers from '../../components/admin/dealers/dealers'

export default {
    // name:'Dealers',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        Dealers
    }
}
</script>
